import RouterGuards from "@/router/router-guards";
import {Router} from "vue-router";


// Per router documentation, adding routes programatically will remove routes of the same name.
// These functions utilize this to remap which components are used for certain routes as a way to toggle on updated UI.
export default class RouterUIToggle {
    private myRouterGuards:RouterGuards;
    private router: Router;

    constructor (router: Router, routerGuards:RouterGuards) {
        this.router = router;
        this.myRouterGuards = routerGuards;
    }
    
    // Add routes for new UI, replacing any in-production UI components.
    public enableNewUI() {
        this.router.addRoute('Proposal',{
            path: 'proposal-head',
            name: 'ProposalHeader',
            component: () => import('@/views/proposal/newUI/ProposalMainArea.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'proposal-info',
            name: 'ProposalScheduling',
            component: () => import('@/views/proposal/newUI/ScheduleChecklist/ScheduleChecklist.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'text-maintenance',
            name: 'ProposalTextMaintenance',
            component: () => import('@/views/proposal/base/forms/TextMaintenance.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'sample-data',
            name: 'ProposalSample',
            component: () => import('@/views/proposal/base/forms/SampleData.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'product-bom-table',
            name: 'ProposalCosting',
            component: () => import('@/views/proposal/newUI/Costing/NewProductBomTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: '/proposal/:proposalNumber/component-bom-screen/:componentNumber/:componentBomID',
            name: 'ComponentBom',
            component: () => import('@/views/proposal/product-bom/component-bom/ComponentBomScreen.vue'),
            beforeEnter: this.myRouterGuards.ifAuthenticated,
        })
        this.router.addRoute('Proposal', {
            path: '/proposal/:proposalNumber/component-bom-items-table/:componentNumber/:componentBomID',
            name: 'CmpBomItems',
            component: () => import('@/views/proposal/product-bom/component-bom/ComponentBomItemsTable.vue'),
            beforeEnter: this.myRouterGuards.ifAuthenticated,
        })
        this.router.addRoute('Proposal', {
            path: '/proposal/:proposalNumber/component-bom-route-items-table/:componentNumber/:componentBomID',
            name: 'CmpRouteItems',
            component: () => import('@/views/proposal/product-bom/component-bom/ComponentBomRouteItemsTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: '/proposal/:proposalNumber/component-bom-tooling-items-table/:componentNumber/:componentBomID',
            name: 'CmpToolingItems',
            component: () => import('@/views/proposal/product-bom/component-bom/ComponentBomToolingItemsTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'purchased-item-table',
            name: 'PurchasedItem',
            component: () => import('@/views/proposal/product-bom/purchased-item/PurchasedItemTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'route-item-table',
            name: 'AssemblyRoute',
            component: () => import('@/views/proposal/product-bom/prod-route-item/RouteItemTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'amort-item-table',
            name: 'AmortizedTable',
            component: () => import('@/views/proposal/product-bom/amort-item/AmortItemTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'sub-assemblies',
            name: 'SubAssemblies',
            component: () => import('@/views/proposal/base/forms/SubAssembly/SubAssembly.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'component-totals',
            name: 'ProposalComponentTotals',
            component: () => import('@/views/proposal/product-bom/component-bom/ComponentTotals.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'cost-history',
            name: 'ProposalCost',
            component: () => import('@/views/proposal/base/forms/CostHistory.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'reports',
            name: 'ProposalReports',
            component: () => import('@/views/proposal/reports/ReportMenu.vue')
        })
        this.router.addRoute('', {
            path: '/DesignQueueAssignment',
            name: 'DesignQueueAssignment',
            component: () => import('@/views/DesignQueue/newDesignerUI/DesignerSchedulingQueue.vue')
        })
        this.router.replace(this.router.currentRoute.value.fullPath);
    }

// Add routes for in-production components, replacing any in-devlopment UI components
     public disableNewUI() {
        this.router.addRoute('Proposal',{
            path: 'proposal-head',
            name: 'ProposalHeader',
            component: () => import('@/views/proposal/base/forms/ProposalHead.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'proposal-info',
            name: 'ProposalScheduling',
            component: () => import('@/views/proposal/base/forms/ProposalInfo.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'text-maintenance',
            name: 'ProposalTextMaintenance',
            component: () => import('@/views/proposal/base/forms/TextMaintenance.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'sample-data',
            name: 'ProposalSample',
            component: () => import('@/views/proposal/base/forms/SampleData.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'product-bom-table',
            name: 'ProposalCosting',
            component: () => import('@/views/proposal/product-bom/ProductBomTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: '/proposal/:proposalNumber/component-bom-screen/:componentNumber/:componentBomID',
            name: 'ComponentBom',
            component: () => import('@/views/proposal/product-bom/component-bom/ComponentBomScreen.vue'),
            beforeEnter: this.myRouterGuards.ifAuthenticated,
        })
        this.router.addRoute('Proposal', {
            path: '/proposal/:proposalNumber/component-bom-items-table/:componentNumber/:componentBomID',
            name: 'CmpBomItems',
            component: () => import('@/views/proposal/product-bom/component-bom/ComponentBomItemsTable.vue'),
            beforeEnter: this.myRouterGuards.ifAuthenticated,
        })
        this.router.addRoute('Proposal', {
            path: '/proposal/:proposalNumber/component-bom-route-items-table/:componentNumber/:componentBomID',
            name: 'CmpRouteItems',
            component: () => import('@/views/proposal/product-bom/component-bom/ComponentBomRouteItemsTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: '/proposal/:proposalNumber/component-bom-tooling-items-table/:componentNumber/:componentBomID',
            name: 'CmpToolingItems',
            component: () => import('@/views/proposal/product-bom/component-bom/ComponentBomToolingItemsTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'purchased-item-table',
            name: 'PurchasedItem',
            component: () => import('@/views/proposal/product-bom/purchased-item/PurchasedItemTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'route-item-table',
            name: 'AssemblyRoute',
            component: () => import('@/views/proposal/product-bom/prod-route-item/RouteItemTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'amort-item-table',
            name: 'AmortizedTable',
            component: () => import('@/views/proposal/product-bom/amort-item/AmortItemTable.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'sub-assemblies',
            name: 'SubAssemblies',
            component: () => import('@/views/proposal/base/forms/SubAssembly/SubAssembly.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'component-totals',
            name: 'ProposalComponentTotals',
            component: () => import('@/views/proposal/product-bom/component-bom/ComponentTotals.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'cost-history',
            name: 'ProposalCost',
            component: () => import('@/views/proposal/base/forms/CostHistory.vue')
        })
        this.router.addRoute('Proposal', {
            path: 'reports',
            name: 'ProposalReports',
            component: () => import('@/views/proposal/reports/ReportMenu.vue')
        })
         this.router.addRoute('', {
             path: '/DesignQueueAssignment',
             name: 'DesignQueueAssignment',
             component: () => import('@/views/DesignQueue/DesignerWorkQueue.vue')
         })
        this.router.replace(this.router.currentRoute.value.fullPath);
    }

}

